import { PageWithTitle } from 'src/Common/components';
import styled from '@emotion/styled';
import { Box, Stack, Typography } from '@mui/material';
import { LiveBadge } from 'src/Common/components/LiveBadge/LiveBadge';
import { ToggleUpdatesButton } from 'src/Common/components/ToggleUpdatesButton/ToggleUpdatesButton';
import { usePredictions } from '../context';
import { PredictionsTable } from '../components';

const PredictionsPageContent = () => {
  const { opportunities, isConnected, count } = usePredictions();

  return (
    <PageWithTitle>
      <Stack direction="row">
        <Box style={{ width: '100%' }}>
          <Toolbar>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography
                  variant="h6"
                  color="text.primary"
                  sx={{ whiteSpace: 'nowrap' }}
                >
                  Opportunities
                </Typography>
                {count > 0 && (
                  <Typography
                    sx={{
                      fontSize: '0.8rem',
                      color: 'grey.500',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    ({count} opportunities)
                  </Typography>
                )}
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <LiveBadge isLive={isConnected} />
                <ToggleUpdatesButton subsystem="predictions" />
              </Stack>
            </Box>
          </Toolbar>

          <PredictionsTable
            data={opportunities}
            isLoading={isConnected && opportunities.length === 0}
          />
        </Box>
      </Stack>
    </PageWithTitle>
  );
};

export const PredictionsPage = () => {
  return <PredictionsPageContent />;
};

const Toolbar = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
});
